import NiceModal from '@ebay/nice-modal-react';

import ResetPermissionsModal from '@/modals/ResetPermissionsModal';
import ResetLocationModal from '@/modals/ResetLocationModal';
import { modals } from '@/modals';

NiceModal.register(
  modals.RESET_PERMISSIONS_MODAL,
  ResetPermissionsModal,
  { keepMounted: false }
);

NiceModal.register(
  modals.RESET_LOCATION_MODAL,
  ResetLocationModal,
  { keepMounted: false }
);

export default NiceModal;
